<template>
  <router-view />
</template>

<script>
  export default {
    name: 'AccountXC',
  };
</script>

<style src="./styles/app.scss" lang="scss"/>


